exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".scr-tp-wrp{position:fixed;bottom:13%;right:6%;z-index:1000}.scr-btn-wrp{cursor:pointer;width:45px;height:45px;background:#007d43;color:#fff;font-size:15px;display:flex;align-items:center;justify-content:center;padding:10px;flex-direction:column;border-radius:50%;box-shadow:0 3px 6px #00000029}.scr-btn-wrp:hover{opacity:.9}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-529d9de5","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/layouts/MobileScrollUp.vue
// module id = 558
// module chunks = 187